// Constants for CreateTransactionCharges component

// Grid Configuration
export const GRID_KEY = "createTransactionChargesGrid";
export const GRID_CONTAINER_ID = "chargesGridContainer";

// API Endpoints
export const API_ENDPOINTS = {
    GET_AVAILABLE_CHARGES: "/wm/TransactionHeaderOperations/GetAvailableCharges",
    APPLY_TRANSACTION_CHARGES: "/wm/TransactionHeaderOperations/ApplyTransactionCharges"
};

// Empty GUID
export const EMPTY_GUID = "00000000-0000-0000-0000-000000000000";

// Column Configuration
export const COLUMN_WIDTHS = {
    APPLY: 60,
    CHARGE_CODE: 100,
    DESCRIPTION: 180,
    DESC_REFERENCE: 120,
    CUSTOMER: 100,
    BILL_AS: 80,
    RATE: 100,
    AMOUNT: 100
};

export const COLUMN_CAPTIONS = {
    APPLY: "Apply",
    CHARGE_CODE: "Charge Code",
    DESCRIPTION: "Description",
    DESC_REFERENCE: "Desc/Reference",
    CUSTOMER: "Customer",
    BILL_AS: "Bill As",
    RATE: "Rate",
    AMOUNT: "Amount"
};

export const COLUMN_FORMATS = {
    NUMBER: "#,##0.00",
    CURRENCY: "$#,##0.00"
};

// Column Chooser Configuration
export const COLUMN_CHOOSER = {
    TITLE: "Choose Column",
    WIDTH: 290,
    HEIGHT: 290,
    SORT_ORDER: "asc",
    SEARCH_PLACEHOLDER: "Search column"
};

// Button Texts
export const BUTTON_TEXTS = {
    APPLY: "Apply",
    CANCEL: "Cancel"
};

// Default Values
export const DEFAULT_VALUES = {
    BILL_AS: 1.00,
    RATE: 0,
    AMOUNT: 0,
    UNIT_CHARGE_FACTOR: 1.00
};

// Load Panel Configuration
export const LOAD_PANEL = {
    SHADING_COLOR: "rgba(0,0,0,0.4)",
    SHOW_INDICATOR: true,
    SHADING: true,
    SHOW_PANE: true,
    HIDE_ON_OUTSIDE_CLICK: false
};

// HTTP Headers
export const HTTP_HEADERS = {
    CONTENT_TYPE: "application/json"
};

// Data Field Names
export const DATA_FIELDS = {
    APPLY: "apply",
    CHARGE_CODE: "chargeCode",
    DESCRIPTION: "description",
    DESC_REFERENCE: "descReference",
    CUSTOMER: "customer",
    BILL_AS: "billAs",
    RATE: "rate",
    AMOUNT: "amount",
    ROWID: "rowid"
};

// Data Types
export const DATA_TYPES = {
    BOOLEAN: "boolean",
    STRING: "string",
    NUMBER: "number"
};

// Alignment
export const ALIGNMENT = {
    CENTER: "center",
    RIGHT: "right"
};

